(() => {
  const mount = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = JSON.parse(root.querySelector('[data-hfb-data]').textContent);
    const vehicleModel = data.vehicle?.model || 'Toyota HiAce 2019+ (current model)';
    data.base.variants = data.base.variants.filter(v => v.option1 === vehicleModel);
    if (!data.base.variants.length) {
      root.querySelector('[data-hfb-action]').disabled = true;
      root.querySelector('[data-hfb-error]').textContent = data.labels.unavailable;
      return;
    }
    const labels = Object.fromEntries(Object.entries(data.labels).map(([key, value]) => {
      const decoder = document.createElement('textarea');
      decoder.innerHTML = value;
      return [key, decoder.value];
    }));
    const el = (tag, text, cls) => { const n = document.createElement(tag); if (text !== undefined) n.textContent = text; if (cls) n.className = cls; return n; };
    const find = name => root.querySelector('[data-hfb-' + name + ']');
    const money = value => new Intl.NumberFormat('en-AU', { style: 'currency', currency: data.currency || 'AUD' }).format(value / 100);
    const models = [...new Set(data.base.variants.map(v => v.option1))];
    const state = { model: models[0], variant: data.base.variants[0], addons: {}, error: '' };
    const positions = {
      behind_driver: { label: labels.behind_driver, x: 835, y: 620 },
      left_wheel: { label: labels.left_wheel, x: 550, y: 970 },
      right_wheel: { label: labels.right_wheel, x: 850, y: 970 },
      rear_left: { label: labels.rear_left, x: 600, y: 1130 },
      rear_right: { label: labels.rear_right, x: 800, y: 1130 },
      passenger_door: { label: labels.passenger_door, x: 460, y: 660 },
      driver_door: { label: labels.driver_door, x: 940, y: 660 },
      driver_step: { label: labels.driver_step },
      confirm_position: { label: labels.confirm_position }
    };
    const configs = { shelving: ['behind_driver','left_wheel','right_wheel'], easy: ['rear_left','rear_right','passenger_door','driver_door'], milwaukee: ['rear_left','rear_right','passenger_door','driver_door'], milwaukee_access: ['passenger_door','driver_door'], access: ['passenger_door','driver_door'], step: ['driver_step'], power: ['confirm_position'] };
    if (data.vehicle?.key === 'hiace-2005-2019') {
      for (const key of ['easy','milwaukee','milwaukee_access','access']) configs[key] = configs[key].filter(p => p !== 'driver_door');
    }
    const names = { behind_driver: "Behind driver's seat", left_wheel: 'Left wheel arch', right_wheel: 'Right wheel arch' };
    const zone = p => ({ behind_driver: 'driver_door', rear_left: 'left_wheel', rear_right: 'right_wheel' }[p] || p);
    const sideDoor = p => ['passenger_door','driver_door'].includes(p);
    const frontPosition = p => sideDoor(zone(p));
    const fullWidth = (key, p) => ['easy','milwaukee'].includes(key) && sideDoor(p);
    const blockedBy = (key, p) => {
      if (p === 'confirm_position') return '';
      for (const [otherKey, chosen] of Object.entries(state.addons)) {
        if (otherKey === key || !chosen.enabled) continue;
        for (const otherPosition of chosen.positions) {
          const sameZone = zone(p) === zone(otherPosition);
          const crossFront = frontPosition(p) && frontPosition(otherPosition) && (fullWidth(key, p) || fullWidth(otherKey, otherPosition));
          if (crossFront) return labels.reason_full_width;
          if (sameZone) return labels.reason_occupied;
        }
      }
      return '';
    };
    const currentVariants = () => data.base.variants.filter(v => v.option1 === state.model);
    const controls = {};
    const makeOption = (value, text) => { const n = el('option', text); n.value = value; return n; };
    find('model').textContent = state.model.replace(' (current model)', '');
    const drawOptions = () => {
      const select = find('drawers');
      select.replaceChildren();
      const variants = currentVariants();
      if (!variants.some(v => v.id === state.variant.id)) state.variant = variants[0];
      for (const v of variants) select.append(makeOption(String(v.id), v.option2));
      select.value = String(state.variant.id);
      find('model-note').textContent = data.vehicle?.key === 'hiace-2005-2019' ? labels.old_note : labels.new_note;
    };
    const title = item => item.product?.title || item.label || item.key;
    for (const item of data.addons) {
      if (item.key === 'step' && !/^Toyota HiAce/i.test(vehicleModel)) continue;
      if (item.key === 'power') { const note = el('p', labels.power_coming || 'Coming Soon', 'hfb__note'); find('addons-power').append(note); continue; }
      state.addons[item.key] = { enabled: false, positions: [] };
      const card = el('article', undefined, 'hfb__module');
      const head = el('div', undefined, 'hfb__module-head');
      if (item.product?.featured_image) { const img = el('img'); img.src = item.product.featured_image; img.alt = title(item); img.loading = 'lazy'; img.width = 75; img.height = 75; head.append(img); }
      const wrap = el('label');
      const line = el('span', undefined, 'hfb__module-title');
      const check = el('input'); check.type = 'checkbox'; check.dataset.hfbModule = item.key;
      line.append(check, document.createTextNode(title(item)));
      const price = item.product?.variants?.[0]?.price;
      wrap.append(line, el('span', price > 0 ? money(price) + (item.key === 'shelving' ? ' ' + labels.bay : '') : labels.quote_price, 'hfb__module-price'));
      head.append(wrap); card.append(head);
      if (item.key === 'step') card.append(el('p', labels.step_fitment, 'hfb__note'));
      const slot = el('div', undefined, 'hfb__position'); slot.hidden = true; card.append(slot);
      const reason = el('p', undefined, 'hfb__note hfb__restriction'); reason.hidden = true; reason.id = 'hfb-restriction-' + item.key + '-' + data.base.id; reason.setAttribute('aria-live','polite'); card.append(reason); check.setAttribute('aria-describedby',reason.id);
      if (['step','power'].includes(item.key) && !(item.product?.variants?.[0]?.price > 0)) card.append(el('p', labels.placeholder, 'hfb__note'));
      const group = { shelving: 'shelving', step: 'shelving', milwaukee: 'sliders', easy: 'access', access: 'access', milwaukee_access: 'access', power: 'power' }[item.key];
      find('addons-' + group).append(card);
      controls[item.key] = { check, slot, item, reason };
    }
    const renderPositions = () => {
      for (const [key, c] of Object.entries(controls)) {
        const chosen = state.addons[key];
        const available = configs[key];
        c.check.disabled = !chosen.enabled && available.every(p => blockedBy(key, p));
        c.reason.textContent = labels.placement_unavailable;
        c.reason.hidden = !c.check.disabled;
        chosen.positions = chosen.positions.filter(p => available.includes(p));
        c.slot.replaceChildren(); c.slot.hidden = !chosen.enabled;
        if (key === 'step') {
          chosen.positions = chosen.enabled ? ['driver_step'] : [];
          c.slot.hidden = true;
          continue;
        }
        if (key === 'shelving') {
          for (const p of available) {
            const label = el('label', undefined, 'hfb__bay');
            const check = el('input'); check.type = 'checkbox'; check.checked = chosen.positions.includes(p); check.dataset.hfbBay = p;
            const owner = blockedBy(key, p); check.disabled = Boolean(owner);
            if (owner) { label.title = owner; check.setAttribute('aria-describedby',c.reason.id); }
            label.append(check, document.createTextNode(positions[p].label + (owner ? ' (' + labels.blocked_option + ')' : ''))); c.slot.append(label);
          }
        } else {
          const label = el('label', labels.position); const select = el('select'); select.dataset.hfbPosition = key; select.setAttribute('aria-describedby',c.reason.id);
          select.append(makeOption('', labels.position));
          for (const p of available) {
            const owner = blockedBy(key, p);
            const option = makeOption(p, positions[p].label + (owner ? ' (' + labels.blocked_option + ')' : ''));
            option.disabled = Boolean(owner); select.append(option);
          }
          if (available.length === 1) chosen.positions = [available[0]];
          select.value = chosen.positions[0] || '';
          label.append(select); c.slot.append(label);
        }
      }
    };
    const selection = () => {
      const lines = [];
      let unknown = !(state.variant.price > 0), total = state.variant.price, error = '';
      const occupied = new Set();
      for (const [key, chosen] of Object.entries(state.addons)) {
        if (!chosen.enabled) continue;
        const item = controls[key].item;
        if (!chosen.positions.length) error = labels.position + ': ' + title(item);
        for (const p of chosen.positions) {
          if (!configs[key].includes(p)) error = labels.unavailable + ': ' + positions[p]?.label;
          const canonical = zone(p);
          const owner = blockedBy(key, p);
          if (owner) error = labels.conflict + ': ' + positions[p].label + ' / ' + owner;
          if (p !== 'confirm_position' && occupied.has(canonical)) error = labels.conflict + ': ' + positions[p].label;
          if (p !== 'confirm_position') occupied.add(canonical);
          const variant = key === 'shelving' ? item.product?.variants.find(v => v.title === names[p]) : item.product?.variants?.[0];
          if (!(variant?.price > 0)) unknown = true;
          if (variant && !variant.available) error = labels.unavailable + ': ' + title(item);
          total += variant?.price || 0;
          lines.push({ key, title: title(item), position: p, variant, price: variant?.price || 0 });
        }
      }
      if (!state.variant.available) error = labels.unavailable + ': ' + state.variant.option2;
      return { lines, total, unknown, error };
    };
    const summaryText = selected => [labels.model + ': ' + state.model, state.variant.option2 + ' (' + (state.variant.price > 0 ? money(state.variant.price) : labels.quote_price) + ')', ...selected.lines.map(line => line.title + ' / ' + positions[line.position].label + ' / ' + (line.price > 0 ? money(line.price) : labels.quote_price)), labels.priced_total + ': ' + money(selected.total), labels.notes + ': ' + find('notes').value].join('\n');
    const geometry = {
      '4drawer-rearside': { width:771, height:1024, deck:[259,344,253,484] },
      'twin-opposed': { width:741, height:1024, deck:[245,345,251,485] },
      '6drawer': { width:705, height:1024, deck:[233,354,257,495] },
      'twin-rear': { width:1400, height:1400, deck:[535,550,349,662] },
      'twin-side': { width:1400, height:1400, deck:[531,546,350,662] },
      'quad-side': { width:1400, height:1400, deck:[526,546,348,664] },
      'single-side': { width:1400, height:1400, deck:[521,551,345,660] },
      '3drawer': { width:1400, height:1400, deck:[527,546,348,665] },
      'twin-opposed-side': { width:1400, height:1400, deck:[521,547,348,664] }
    };
    const zones = {
      driver_door: { color:'#397fcb', bounds:[.72,.015,.265,.49] },
      passenger_door: { color:'#169a9b', bounds:[.015,.015,.265,.49] },
      left_wheel: { color:'#9757c5', bounds:[.015,.505,.265,.48] },
      right_wheel: { color:'#65ad35', bounds:[.72,.505,.265,.48] }
    };
    const svgEl = (name, attrs) => { const n = document.createElementNS('http://www.w3.org/2000/svg', name); for (const [k,v] of Object.entries(attrs)) n.setAttribute(k,v); return n; };
    const update = () => {
      const selected = selection();
      const layout = data.layouts.find(l => state.variant.layoutKey ? l.key === state.variant.layoutKey : l.title === state.variant.option2);
      if (layout) find('layout').src = layout.image;
      find('markers').replaceChildren(); find('legend').replaceChildren();
      const plan = geometry[layout?.key];
      if (plan) find('markers').setAttribute('viewBox', '0 0 ' + plan.width + ' ' + plan.height);
      selected.lines.forEach(line => {
        const p = positions[line.position], baseRegion = zones[zone(line.position)];
        const region = baseRegion ? { ...baseRegion, color:line.key.startsWith('milwaukee') ? '#c8102e' : baseRegion.color } : null;
        const legendItem = el('li');
        const swatch = el('span', undefined, 'hfb__swatch'); swatch.style.backgroundColor = region?.color || '#888'; swatch.setAttribute('aria-hidden','true');
        legendItem.append(swatch, document.createTextNode(line.title + ': ' + p.label)); find('legend').append(legendItem);
        if (region && plan) {
          const [left,top,width,height] = plan.deck, [x,y,w,h] = region.bounds;
          const horizontal = ['easy','milwaukee'].includes(line.key) && sideDoor(line.position);
          const blockWidth = horizontal ? Math.min(h*height, .97*width) : w*width;
          const blockHeight = horizontal ? w*width : h*height;
          const blockLeft = horizontal ? (line.position === 'driver_door' ? left+.985*width-blockWidth : left+.015*width) : left+x*width;
          const block = svgEl('rect', { x:blockLeft, y:top+y*height, width:blockWidth, height:blockHeight, fill:region.color, 'fill-opacity':.7, stroke:region.color, 'stroke-width':2, 'data-zone':zone(line.position) });
          const titleNode = svgEl('title', {}); titleNode.textContent = line.title + ': ' + p.label; block.append(titleNode); find('markers').append(block);
        }
      });
      find('total').textContent = money(selected.total);
      find('pending').textContent = selected.unknown ? labels.pending_note : '';
      find('action').textContent = labels.add_cart;
      find('action').disabled = Boolean(selected.error) || selected.unknown;
      find('error').textContent = state.error || selected.error;
      find('quote-body').value = summaryText(selected);
      root.lawsonEnquiry={kind:'Van',vehicle:state.model,product:data.base.title||'Van builder',specification:summaryText(selected),items:[{variantId:String(state.variant.id),quantity:1,description:state.variant.option2},...selected.lines.filter(l=>l.variant).map(l=>({variantId:String(l.variant.id),quantity:1,description:l.title+' / '+positions[l.position].label}))]};
      const url = new URL(window.location.href); url.searchParams.set('variant',state.variant.id); window.history.replaceState({},'',url);
    };
    root.addEventListener('change', event => {
      const target = event.target; state.error = '';
      if (target === find('drawers')) state.variant = currentVariants().find(v => String(v.id) === target.value) || state.variant;
      if (target.dataset.hfbModule) { const key = target.dataset.hfbModule; state.addons[key].enabled = target.checked; renderPositions(); }
      if (target.dataset.hfbPosition) {
        const key = target.dataset.hfbPosition;
        if (!target.value || (configs[key].includes(target.value) && !blockedBy(key, target.value))) state.addons[key].positions = target.value ? [target.value] : [];
      }
      if (target.dataset.hfbBay) {
        const p = target.dataset.hfbBay, chosen = state.addons.shelving;
        if (!target.checked || !blockedBy('shelving', p)) chosen.positions = target.checked ? [...new Set([...chosen.positions,p])] : chosen.positions.filter(v => v !== p);
      }
      renderPositions(); update();
    });
    find('reset').addEventListener('click', () => {
      state.variant = currentVariants()[0]; state.error = '';
      for (const [key, chosen] of Object.entries(state.addons)) {
        chosen.enabled = false; chosen.positions = []; controls[key].check.checked = false;
      }
      find('notes').value = ''; find('quote').open = false;
      drawOptions(); renderPositions(); update();
      find('drawers').focus();
    });
    find('notes').addEventListener('input', update);
    find('action').addEventListener('click', async () => {
      const selected = selection();
      if (selected.error) return;
      if (selected.unknown) { find('quote').open = true; find('quote').querySelector('input[type=email]').focus(); return; }
      const token = (data.vehicle ? 'VAN-' : 'HIACE-') + Date.now().toString(36);
      const properties = { [data.vehicle ? 'Vehicle' : 'HiAce model']: state.model, 'Fitout reference': token, 'Equipment notes': find('notes').value };
      const items = [{ id: state.variant.id, quantity: 1, properties: { ...properties, 'Drawer system': state.variant.option2 } }, ...selected.lines.map(line => ({ id: line.variant.id, quantity: 1, properties: { ...properties, 'Position': positions[line.position].label } }))];
      find('action').disabled = true; find('action').textContent = labels.adding;
      try {
        const response = await fetch(data.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || labels.cart_error);
        window.location.assign(data.root + 'cart');
      } catch (error) { state.error = error.message || labels.cart_error; update(); }
    });
    const requested = new URL(window.location.href).searchParams.get('variant');
    const initial = data.base.variants.find(v => String(v.id) === requested);
    if (initial) { state.variant = initial; state.model = initial.option1; }
    find('model').textContent = state.model.replace(' (current model)', '');
    drawOptions(); renderPositions(); update();
  };
  const start = () => document.querySelectorAll('[data-hiace-builder]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();


